import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { IndexedDbPollService } from '../indexeddb-poll.service';
import { IndexedDbUnitService } from '../indexeddb-unit.service';
import { IPoll } from 'projects/lib-ui/src/shared/interfaces/poll';


export const getPollResolver: ResolveFn<Promise<IPoll | null>> = async (route, state) => {
  const indexedDbPollService = inject(IndexedDbPollService);
  const indexedDbUnitService = inject(IndexedDbUnitService);
  const router = inject(Router);
  const http = inject(HttpClient);
  const pollId = route.params['pollId'];
  const deviceId: string | undefined = route.params['deviceId'];

  let pollReadFailed = false;

  try {
    const poll = await indexedDbPollService.getPollById(pollId);
    if (poll) {
      return poll;
    }
  } catch (e) {
    pollReadFailed = true;
    console.error('Erro ao buscar poll do IndexedDB:', e);
  }

  // A configuração local precisa ser limpa antes de voltar ao setup: enquanto a
  // unit continua no IndexedDB o ConfigGuard reenvia para esta rota, e o
  // resolver volta a cair aqui, gerando um loop infinito de navegação.
  await clearLocalConfig(indexedDbPollService, indexedDbUnitService);

  // Só desvincula quando a pesquisa realmente não está em cache. Uma falha de
  // leitura do IndexedDB não prova ausência e não deve derrubar o vínculo.
  if (deviceId && !pollReadFailed) {
    try {
      await firstValueFrom(
        http.patch(environment.URLAPI + 'Devices/' + 'unlink/' + deviceId, {})
      );
    } catch (e) {
      console.error('Erro ao desvincular device:', e);
    }
  }

  router.navigate(['/setup']);
  return null;
};

async function clearLocalConfig(
  indexedDbPollService: IndexedDbPollService,
  indexedDbUnitService: IndexedDbUnitService
): Promise<void> {
  try {
    await indexedDbPollService.clearDB();
  } catch (e) {
    console.error('Erro ao limpar polls do IndexedDB:', e);
  }

  try {
    await indexedDbUnitService.clearDB();
  } catch (e) {
    console.error('Erro ao limpar unidades do IndexedDB:', e);
  }
}
